<div class="row h-100 m-0 admin-update-prediction">
    <!-- Left Column: Race Entry -->
    <div class="col-xl-6 col-lg-12">
        <div id="race-entry" class="card shadow-sm rounded race-entry race-entry-page pb-0">
            <div class="card-title bg-blue">
                <h4 class="m-0">User Race Prediction</h4>
                <ul class="list-unstyled card-title-details" *ngIf="existingRaceEntryDetail">
                    <li><span>User :</span> {{existingRaceEntryDetail.userName}}</li>
                </ul>
            </div>
            <div class="card-body p-0">
                <div class="row race-entry-details h-100 m-0" *ngIf="!PreLoader">
                    <div class="col-lg-12 p-2">
                        <h5 class="mb-3" *ngIf="raceInfoObj.name">
                            {{raceInfoObj.name}} - {{raceInfoObj.Circuits.name}}, {{raceInfoObj.Circuits.location}},
                            {{raceInfoObj.Circuits.country}}
                        </h5>

                        <!-- Drivers -->
                        <ul class="list-unstyled race-entry-list mb-3 driversRowStyle">
                            <li>
                                <h5>Drivers</h5>
                            </li>
                            <li *ngFor="let driverobj of selectedDrivers">
                                <div class="race-entry-ranking"
                                    [class.selected]="targetPosition === driverobj && showDriverList">
                                    <div class="ranking"
                                        (click)="showDriverList=true; showRaceInfo=false; showConstructorList=false; showDriverListForFastestLap=false; showDriverListForPolePosition=false; showDriverListForMostPosition=false; targetPosition=driverobj">
                                        <span class="position">{{getposition(driverobj.position)}}</span>
                                        <span class="picture">
                                            <i *ngIf="driverobj.selected" class="fa fa-times pull-right cross"
                                                (click)="$event.stopPropagation(); removeFromDriverList(driverobj)"></i>
                                            <img *ngIf="driverobj.selected" [src]="driverobj.drivers.driverPic"
                                                alt="driver" />
                                            <i *ngIf="!driverobj.selected" class="fa fa-plus"></i>
                                        </span>
                                        <span class="name">{{driverobj.selected ? driverobj.drivers.foreName + ' ' +
                                            driverobj.drivers.surName : ' '}}</span>
                                        <span *ngIf="!driverobj.selected">Driver {{driverobj.position}}</span>
                                    </div>
                                </div>
                            </li>
                        </ul>

                        <!-- Constructors -->
                        <ul class="list-unstyled race-entry-list mb-3">
                            <li>
                                <h5>Constructors</h5>
                            </li>
                            <li *ngFor="let constrobj of selectedConstructors">
                                <div class="race-entry-ranking"
                                    [class.selected]="targetConstructorPosition === constrobj && showConstructorList">
                                    <div class="ranking"
                                        (click)="showConstructorList=true; showRaceInfo=false; showDriverList=false; showDriverListForFastestLap=false; showDriverListForPolePosition=false; showDriverListForMostPosition=false; targetConstructorPosition=constrobj">
                                        <span class="position">{{getposition(constrobj.position)}}</span>
                                        <span class="picture">
                                            <i *ngIf="constrobj.selected" class="fa fa-times pull-right cross"
                                                (click)="$event.stopPropagation(); removeFromConstructorList(constrobj)"></i>
                                            <img *ngIf="constrobj.selected"
                                                [src]="constrobj.constructors.constructorPic" alt="constructor" />
                                            <i *ngIf="!constrobj.selected" class="fa fa-plus"></i>
                                        </span>
                                        <span class="name">{{constrobj.selected ? constrobj.constructors.name : '
                                            '}}</span>
                                        <span *ngIf="!constrobj.selected">Constructor {{constrobj.position}}</span>
                                    </div>
                                </div>
                            </li>
                        </ul>

                        <!-- Other Info (FL, PP, MPG) -->
                        <ul class="list-unstyled race-entry-list third-row">
                            <li>
                                <div class="race-entry-ranking lap fastestLapStyle"
                                    [class.selected]="showDriverListForFastestLap">
                                    <div class="position">Fastest Lap</div>
                                    <div class="ranking"
                                        (click)="showDriverListForFastestLap=true; showRaceInfo=false; showDriverList=false; showConstructorList=false; showDriverListForPolePosition=false; showDriverListForMostPosition=false">
                                        <span class="picture">
                                            <i *ngIf="selectedFastestLap.selected" class="fa fa-times pull-right cross1"
                                                (click)="$event.stopPropagation(); removeFromFastestLap()"></i>
                                            <img *ngIf="selectedFastestLap.selected"
                                                [src]="selectedFastestLap.driverPic" alt="driver" />
                                            <i *ngIf="!selectedFastestLap.selected" class="fa fa-plus"></i>
                                        </span>
                                        <span class="name">{{selectedFastestLap.selected ? selectedFastestLap.foreName +
                                            ' ' + selectedFastestLap.surName : ' '}}</span>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="race-entry-ranking pole" [class.selected]="showDriverListForPolePosition">
                                    <div class="position">Pole Position</div>
                                    <div class="ranking"
                                        (click)="showDriverListForPolePosition=true; showRaceInfo=false; showDriverList=false; showConstructorList=false; showDriverListForFastestLap=false; showDriverListForMostPosition=false">
                                        <span class="picture">
                                            <i *ngIf="selectedPolePosition.selected"
                                                class="fa fa-times pull-right cross1"
                                                (click)="$event.stopPropagation(); removeFromPolePosition()"></i>
                                            <img *ngIf="selectedPolePosition.selected"
                                                [src]="selectedPolePosition.driverPic" alt="driver" />
                                            <i *ngIf="!selectedPolePosition.selected" class="fa fa-plus"></i>
                                        </span>
                                        <span class="name">{{selectedPolePosition.selected ?
                                            selectedPolePosition.foreName + ' ' + selectedPolePosition.surName : '
                                            '}}</span>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="race-entry-ranking place" [class.selected]="showDriverListForMostPosition">
                                    <div class="position">Most Places Gained</div>
                                    <div class="ranking"
                                        (click)="showDriverListForMostPosition=true; showRaceInfo=false; showDriverList=false; showConstructorList=false; showDriverListForFastestLap=false; showDriverListForPolePosition=false">
                                        <span class="picture">
                                            <i *ngIf="selectedMostPosition.selected"
                                                class="fa fa-times pull-right cross1"
                                                (click)="$event.stopPropagation(); removeFromMostPosition()"></i>
                                            <img *ngIf="selectedMostPosition.selected"
                                                [src]="selectedMostPosition.driverPic" alt="driver" />
                                            <i *ngIf="!selectedMostPosition.selected" class="fa fa-plus"></i>
                                        </span>
                                        <span class="name">{{selectedMostPosition.selected ?
                                            selectedMostPosition.foreName + ' ' + selectedMostPosition.surName : '
                                            '}}</span>
                                    </div>
                                </div>
                            </li>
                        </ul>

                        <!-- Sprint Entry -->
                        <ul class="list-unstyled race-entry-list mb-3" *ngIf="isSprintEntry">
                            <li>
                                <h5>Sprint Entry</h5>
                            </li>
                            <li *ngFor="let driverobj of sprintEntryDrivers">
                                <div class="race-entry-ranking"
                                    [class.selected]="targetPosition === driverobj && showDriverList">
                                    <div class="ranking"
                                        (click)="showDriverList=true; showRaceInfo=false; showConstructorList=false; showDriverListForFastestLap=false; showDriverListForPolePosition=false; showDriverListForMostPosition=false; targetPosition=driverobj">
                                        <span class="position">{{getposition(driverobj.position)}}</span>
                                        <span class="picture">
                                            <i *ngIf="driverobj.selected" class="fa fa-times pull-right cross"
                                                (click)="$event.stopPropagation(); removeFromSprintDriverList(driverobj)"></i>
                                            <img *ngIf="driverobj.selected" [src]="driverobj.drivers.driverPic"
                                                alt="driver" />
                                            <i *ngIf="!driverobj.selected" class="fa fa-plus"></i>
                                        </span>
                                        <span class="name">{{driverobj.selected ? driverobj.drivers.foreName + ' ' +
                                            driverobj.drivers.surName : ' '}}</span>
                                        <span *ngIf="!driverobj.selected">Driver {{driverobj.position}}</span>
                                    </div>
                                </div>
                            </li>
                        </ul>

                        <div class="text-center">
                            <button class="btn btn-outline-primary mt-4 mb-2 mx-1 mx-sm-2"
                                [routerLink]="['/admin/adminRacePrediction']"
                                [queryParams]="{raceId: raceId}">Cancel</button>
                            <button class="btn btn-primary mt-4 mb-2 mx-1 mx-sm-2" (click)="save()"
                                [disabled]="PreLoaderForSave">Save Changes</button>
                        </div>
                    </div>
                </div>
                <div class="box-loader" *ngIf="PreLoader">
                    <img src="assets/img/progress.svg" alt="Loading...">
                </div>
                <div class="box-loader" *ngIf="PreLoaderForSave">
                    <img src="assets/img/progress.svg" alt="Progress">
                </div>
            </div>
        </div>
    </div>

    <!-- Right Column: Info / Picker -->
    <div class="col-xl-6 col-lg-12">
        <div id="race-info" class="card shadow-sm rounded race-entry race-entry-page pb-0">
            <!-- Title based on state -->
            <div *ngIf="showRaceInfo" class="card-title bg-rose">
                <h4 class="m-0">Race Information</h4>
            </div>
            <div *ngIf="showDriverList" class="card-title bg-rose">
                <h4 class="m-0">Drivers</h4>
                <i class="fa fa-times float-right cursor-pointer" (click)="showInfoOnly()"></i>
            </div>
            <div *ngIf="showConstructorList" class="card-title bg-rose">
                <h4 class="m-0">Constructors</h4>
                <i class="fa fa-times float-right cursor-pointer" (click)="showInfoOnly()"></i>
            </div>
            <div *ngIf="showDriverListForFastestLap" class="card-title bg-rose">
                <h4 class="m-0">Fastest Lap Driver</h4>
                <i class="fa fa-times float-right cursor-pointer" (click)="showInfoOnly()"></i>
            </div>
            <div *ngIf="showDriverListForPolePosition" class="card-title bg-rose">
                <h4 class="m-0">Pole Position Driver</h4>
                <i class="fa fa-times float-right cursor-pointer" (click)="showInfoOnly()"></i>
            </div>
            <div *ngIf="showDriverListForMostPosition" class="card-title bg-rose">
                <h4 class="m-0">Most Places Gained Driver</h4>
                <i class="fa fa-times float-right cursor-pointer" (click)="showInfoOnly()"></i>
            </div>

            <div class="card-body p-0">
                <!-- Race Info View -->
                <div *ngIf="showRaceInfo" class="p-3 race-info">
                    <div class="row align-items-center" *ngIf="!PreLoaderForInfo">
                        <div class="col-lg-12 text-center" *ngIf="circuitSrc">
                            <img [src]="circuitSrc" alt="Circuit" class="img-fluid mb-3" style="max-height: 200px;">
                        </div>
                        <div class="col-lg-12">
                            <h5 class="text-center">{{raceInfoObj.raceName}}</h5>
                            <div class="row">
                                <div class="col-md-6">
                                    <ul class="list-unstyled info-list">
                                        <li><strong>Circuit:</strong> {{raceInfoObj.Circuits.name}}</li>
                                        <li><strong>Location:</strong> {{raceInfoObj.Circuits.location}}</li>
                                        <li><strong>Length:</strong> {{raceInfoObj.Circuits.length}}</li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="list-unstyled info-list">
                                        <li><strong>Laps:</strong> {{raceInfoObj.Circuits.laps}}</li>
                                        <li><strong>Turns:</strong> {{raceInfoObj.Circuits.turns}}</li>
                                        <li><strong>Lap Record:</strong> {{raceInfoObj.Circuits.lapRecord}}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Driver Picker -->
                <div *ngIf="showDriverList" class="p-3 selectable-drivers">
                    <ul class="list-unstyled race-entry-list selectable"
                        *ngIf="responseDriverList?.length > 0; else noDrivers">
                        <li *ngFor="let driver of responseDriverList">
                            <div class="race-entry-ranking"
                                (click)="SourceDetail=driver; interchangeSourceTargetDriver()">
                                <span class="picture"><img [src]="driver.driverPic" alt="driver"></span>
                                <span class="name">{{driver.foreName}} {{driver.surName}}</span>
                            </div>
                        </li>
                    </ul>
                    <ng-template #noDrivers>
                        <div class="text-center p-3">{{noDriver}}</div>
                    </ng-template>
                </div>

                <!-- Constructor Picker -->
                <div *ngIf="showConstructorList" class="p-3 selectable-drivers">
                    <ul class="list-unstyled race-entry-list selectable"
                        *ngIf="responseconstructorList?.length > 0; else noConstrs">
                        <li *ngFor="let constr of responseconstructorList">
                            <div class="race-entry-ranking"
                                (click)="SourceConstructorDetail=constr; interchangeSourceTargetConstructor()">
                                <span class="picture"><img [src]="constr.constructorPic" alt="constructor"></span>
                                <span class="name">{{constr.name}}</span>
                            </div>
                        </li>
                    </ul>
                    <ng-template #noConstrs>
                        <div class="text-center p-3">{{noConstructor}}</div>
                    </ng-template>
                </div>

                <!-- FL Picker -->
                <div *ngIf="showDriverListForFastestLap" class="p-3 selectable-drivers">
                    <ul class="list-unstyled race-entry-list selectable">
                        <li *ngFor="let driver of DriverListForFastestLap">
                            <div class="race-entry-ranking" (click)="sourceFastestLap=driver; FastestlapDetail()">
                                <span class="picture"><img [src]="driver.driverPic" alt="driver"></span>
                                <span class="name">{{driver.foreName}} {{driver.surName}}</span>
                            </div>
                        </li>
                    </ul>
                </div>

                <!-- PP Picker -->
                <div *ngIf="showDriverListForPolePosition" class="p-3 selectable-drivers">
                    <ul class="list-unstyled race-entry-list selectable">
                        <li *ngFor="let driver of DriverListForPolePosition">
                            <div class="race-entry-ranking" (click)="sourcePolePosition=driver; polePositionDetail()">
                                <span class="picture"><img [src]="driver.driverPic" alt="driver"></span>
                                <span class="name">{{driver.foreName}} {{driver.surName}}</span>
                            </div>
                        </li>
                    </ul>
                </div>

                <!-- MPG Picker -->
                <div *ngIf="showDriverListForMostPosition" class="p-3 selectable-drivers">
                    <ul class="list-unstyled race-entry-list selectable">
                        <li *ngFor="let driver of DriverListForMostPosition">
                            <div class="race-entry-ranking"
                                (click)="sourceMostPosition=driver; mostPositionGainedDetail()">
                                <span class="picture"><img [src]="driver.driverPic" alt="driver"></span>
                                <span class="name">{{driver.foreName}} {{driver.surName}}</span>
                            </div>
                        </li>
                    </ul>
                </div>

            </div>
        </div>
    </div>
</div>